import React from 'react';
import { Star } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function Testimonials() {
  return <div className="bg-sage-light/20 border-y border-beige-muted/50" data-id="element-218">
      <Section data-id="element-219">
        <SectionTitle data-id="element-220">Lo que dicen las mamás que ya lo usan</SectionTitle>

        <div className="grid md:grid-cols-3 gap-8 items-start mt-12" data-id="element-221">
          {/* Card 1 — Mamá agotada */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-222">
            <div className="flex items-center gap-4 mb-4" data-id="element-223">
              <div className="w-12 h-12 rounded-full bg-sage flex items-center justify-center flex-shrink-0" data-id="element-224">
                <span className="text-white font-bold text-sm" data-id="element-225">MC</span>
              </div>
              <div data-id="element-226">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-227">Micaela C.</h3>
                <p className="text-sm text-charcoal-light" data-id="element-228">
                  Mamá de León, 8 meses — CABA
                </p>
              </div>
            </div>

            <div className="flex gap-1 mb-4" data-id="element-229">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-230" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-231">
              "Estaba súper agotada y sentía que no hacía lo suficiente por él.
              La guía me salvó, literal. Son cosas re simples que hacemos
              mientras cocino o lo baño. Me sacó un peso de encima enorme."
            </p>
          </div>

          {/* Card 2 — Mamá primeriza */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-232">
            <div className="flex items-center gap-4 mb-4" data-id="element-233">
              <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center flex-shrink-0" data-id="element-234">
                <span className="text-white font-bold text-sm" data-id="element-235">FL</span>
              </div>
              <div data-id="element-236">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-237">
                  Florencia L.
                </h3>
                <p className="text-sm text-charcoal-light" data-id="element-238">
                  Mamá de Alma, 3 meses — Rosario
                </p>
              </div>
            </div>

            <div className="flex gap-1 mb-4" data-id="element-239">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-240" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-241">
              "Como mamá primeriza leía de todo y me mareaba. Esto es directo al
              grano. Me encantó que no necesito comprar juguetes caros, usamos
              cosas de casa y ella se re divierte. Súper recomendable."
            </p>
          </div>

          {/* Card 3 — Menos pantallas */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-beige-muted/50 flex flex-col" data-id="element-242">
            <div className="flex items-center gap-4 mb-4" data-id="element-243">
              <div className="w-12 h-12 rounded-full bg-sage flex items-center justify-center flex-shrink-0" data-id="element-244">
                <span className="text-white font-bold text-sm" data-id="element-245">SG</span>
              </div>
              <div data-id="element-246">
                <h3 className="font-bold text-charcoal text-lg" data-id="element-247">Sofía G.</h3>
                <p className="text-sm text-charcoal-light" data-id="element-248">
                  Mamá de Mateo, 2 años — Córdoba
                </p>
              </div>
            </div>

            <div className="flex gap-1 mb-4" data-id="element-249">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-250" />)}
            </div>

            <p className="text-charcoal-light italic font-playfair leading-relaxed" data-id="element-251">
              "Quería bajarle el tiempo de tele a Mateo pero se me acababan las
              ideas. El bono de 30 ideas sin pantallas es oro puro. Ahora
              jugamos más juntos y lo noto mucho más tranquilo a la tarde."
            </p>
          </div>
        </div>
      </Section>
    </div>;
}